
// import React, { useState, useRef, useEffect } from 'react';
// import { FiMessageCircle, FiX, FiSend } from 'react-icons/fi';
// import { chatbotAPI } from '../../services/api';

// const ChatbotWidget = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { role: 'bot', content: "Bonjour ! Je suis l'assistant virtuel. Comment puis-je vous aider ?" }
//   ]);
//   const [input, setInput] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [sessionId] = useState(() => `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);
//   const messagesEndRef = useRef(null);
//   const [properties, setProperties] = useState([]);

//   useEffect(() => {
//     if (isOpen) messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [messages, isOpen]);

//   const sendMessage = async (e) => {
//     e.preventDefault();
//     if (!input.trim() || loading) return;
    
//     const userMsg = input.trim();
//     setInput('');
//     setMessages(prev => [...prev, { role: 'user', content: userMsg }]);
//     setLoading(true);

//     try {
//       const response = await chatbotAPI.chat({ 
//         message: userMsg, 
//         session_id: sessionId,
//         agency_id: null
//       });
      
//       const data = response?.data;
//       if (!data) {
//         throw new Error('Réponse vide du serveur');
//       }
      
//       // Ajouter la réponse du bot
//       setMessages(prev => [...prev, { 
//         role: 'bot', 
//         content: data.response || data.message || "Je n'ai pas compris. Pouvez-vous reformuler ?"
//       }]);
      
//       // Sauvegarder les propriétés trouvées si disponibles
//       if (data.properties && data.properties.length > 0) {
//         setProperties(data.properties);
//       }
      
//     } catch (error) {
//       console.error('Erreur chatbot:', error);
//       setMessages(prev => [...prev, { 
//         role: 'bot', 
//         content: "Désolé, une erreur technique s'est produite. Veuillez réessayer ou nous contacter directement."
//       }]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Rendu des propriétés sous forme de cartes
//   const renderProperties = () => {
//     if (properties.length === 0) return null;
    
//     return (
//       <div style={{ marginTop: '12px', padding: '8px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
//         <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#666' }}>
//           Biens trouvés :
//         </div>
//         {properties.map((prop, idx) => (
//           <div 
//             key={idx} 
//             style={{ 
//               padding: '8px', 
//               marginBottom: '8px', 
//               backgroundColor: 'white', 
//               borderRadius: '6px',
//               border: '1px solid #e0e0e0',
//               cursor: 'pointer'
//             }}
//             onClick={() => window.location.href = `/announcements/${prop.slug || prop.id}`}
//           >
//             <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{prop.title}</div>
//             <div style={{ fontSize: '12px', color: '#666' }}>
//               {prop.city} - {parseInt(prop.price || 0).toLocaleString()} XOF
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <>
//       {/* Bouton flottant */}
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         style={{
//           position: 'fixed',
//           bottom: '24px',
//           right: '24px',
//           width: '60px',
//           height: '60px',
//           borderRadius: '50%',
//           backgroundColor: '#007bff',
//           color: 'white',
//           border: 'none',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//           zIndex: 1000,
//           transition: 'transform 0.2s',
//         }}
//         onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
//         onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//       >
//         {isOpen ? <FiX size={28} /> : <FiMessageCircle size={28} />}
//       </button>

//       {/* Fenêtre de chat */}
//       {isOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             bottom: '100px',
//             right: '24px',
//             width: '380px',
//             height: '550px',
//             backgroundColor: 'white',
//             borderRadius: '12px',
//             boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//             display: 'flex',
//             flexDirection: 'column',
//             zIndex: 1000,
//             overflow: 'hidden',
//           }}
//         >
//           {/* En-tête */}
//           <div
//             style={{
//               padding: '16px',
//               backgroundColor: '#007bff',
//               color: 'white',
//               fontWeight: 'bold',
//               fontSize: '16px',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//             }}
//           >
//             <span>🤖 Assistant Immobilier</span>
//             <button
//               onClick={() => setIsOpen(false)}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 color: 'white',
//                 cursor: 'pointer',
//                 fontSize: '20px',
//               }}
//             >
//               <FiX size={20} />
//             </button>
//           </div>

//           {/* Messages */}
//           <div
//             style={{
//               flex: 1,
//               overflowY: 'auto',
//               padding: '16px',
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '12px',
//               backgroundColor: '#f7f7f7',
//             }}
//           >
//             {messages.map((msg, idx) => (
//               <div key={idx}>
//                 <div
//                   style={{
//                     display: 'flex',
//                     justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start',
//                   }}
//                 >
//                   <div
//                     style={{
//                       maxWidth: '80%',
//                       padding: '10px 14px',
//                       borderRadius: '12px',
//                       backgroundColor: msg.role === 'user' ? '#007bff' : '#e9ecef',
//                       color: msg.role === 'user' ? 'white' : '#333',
//                       wordWrap: 'break-word',
//                       fontSize: '14px',
//                       lineHeight: '1.5',
//                       whiteSpace: 'pre-wrap',
//                     }}
//                   >
//                     {msg.content}
//                   </div>
//                 </div>
//                 {/* Afficher les propriétés après le message du bot si c'est le dernier */}
//                 {msg.role === 'bot' && idx === messages.length - 1 && properties.length > 0 && renderProperties()}
//               </div>
//             ))}
//             {loading && (
//               <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
//                 <div
//                   style={{
//                     padding: '10px 14px',
//                     borderRadius: '12px',
//                     backgroundColor: '#e9ecef',
//                     color: '#666',
//                     fontSize: '14px',
//                   }}
//                 >
//                   <em>L'assistant écrit...</em>
//                 </div>
//               </div>
//             )}
//             <div ref={messagesEndRef} />
//           </div>

//           {/* Suggestions rapides */}
//           {messages.length < 3 && !loading && (
//             <div
//               style={{
//                 padding: '8px 12px',
//                 borderTop: '1px solid #e0e0e0',
//                 backgroundColor: 'white',
//                 display: 'flex',
//                 gap: '8px',
//                 flexWrap: 'wrap',
//               }}
//             >
//               {['Appartement à louer', 'Acheter une villa', 'Prix des terrains', 'Comment contacter ?'].map((suggestion) => (
//                 <button
//                   key={suggestion}
//                   onClick={() => {
//                     setInput(suggestion);
//                     // Envoyer automatiquement après un court délai
//                     setTimeout(() => {
//                       const fakeEvent = { preventDefault: () => {} };
//                       sendMessage(fakeEvent);
//                     }, 100);
//                   }}
//                   style={{
//                     padding: '6px 12px',
//                     backgroundColor: '#f1f3f5',
//                     border: '1px solid #dee2e6',
//                     borderRadius: '20px',
//                     fontSize: '12px',
//                     cursor: 'pointer',
//                     color: '#495057',
//                   }}
//                 >
//                   {suggestion}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* Formulaire d'envoi */}
//           <form
//             onSubmit={sendMessage}
//             style={{
//               padding: '12px',
//               borderTop: '1px solid #e0e0e0',
//               display: 'flex',
//               gap: '8px',
//               backgroundColor: 'white',
//             }}
//           >
//             <input
//               type="text"
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               placeholder="Posez votre question..."
//               disabled={loading}
//               style={{
//                 flex: 1,
//                 padding: '10px',
//                 border: '1px solid #dee2e6',
//                 borderRadius: '6px',
//                 fontSize: '14px',
//                 outline: 'none',
//                 fontFamily: 'inherit',
//               }}
//             />
//             <button
//               type="submit"
//               disabled={loading || !input.trim()}
//               style={{
//                 padding: '10px 16px',
//                 backgroundColor: '#007bff',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 opacity: loading || !input.trim() ? 0.6 : 1,
//                 transition: 'opacity 0.2s',
//               }}
//             >
//               <FiSend size={18} />
//             </button>
//           </form>
//         </div>
//       )}
//     </>
//   );
// };

// export default ChatbotWidget;
// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { FiMessageCircle, FiX, FiSend, FiMapPin, FiHome, FiPhone, FiChevronRight, FiLoader } from 'react-icons/fi';
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// const ChatbotWidget = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [sessionId, setSessionId] = useState(() => {
//     const saved = localStorage.getItem('chatbot_session_id');
//     if (saved) return saved;
//     const id = `sess_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
//     localStorage.setItem('chatbot_session_id', id);
//     return id;
//   });
  
//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [isFirstOpen, setIsFirstOpen] = useState(true);

//   // Message d'accueil initial
//   useEffect(() => {
//     if (messages.length === 0) {
//       setMessages([{
//         id: 'welcome',
//         role: 'bot',
//         content: "Bonjour ! 👋\n\nJe suis l'assistant virtuel de **MaliImmo**. Je peux vous aider à trouver un bien à louer ou à acheter chez nos agences partenaires.\n\nQue recherchez-vous ?",
//         suggestions: ['Louer un appartement', 'Acheter une maison', 'Aide'],
//         properties: [],
//         timestamp: new Date().toISOString()
//       }]);
//     }
//   }, []);

//   // Scroll auto & focus
//   useEffect(() => {
//     if (isOpen) {
//       messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//       if (!isFirstOpen) {
//         setTimeout(() => inputRef.current?.focus(), 100);
//       }
//       setIsFirstOpen(false);
//       setUnreadCount(0);
//     }
//   }, [messages, isOpen, isFirstOpen]);

//   const sendMessage = useCallback(async (text) => {
//     if (!text.trim() || loading) return;
    
//     const userMsg = { id: `u_${Date.now()}`, role: 'user', content: text, timestamp: new Date().toISOString() };
//     setMessages(prev => [...prev, userMsg]);
//     setInput('');
//     setLoading(true);

//     try {
//       const { data } = await axios.post(`${API_URL}/chatbot/message`, {
//         message: text,
//         session_id: sessionId,
//         agency_id: null // Recherche multi-agences
//       });

//       const botMsg = {
//         id: `b_${Date.now()}`,
//         role: 'bot',
//         content: data.response || "Je n'ai pas compris, pouvez-vous reformuler ?",
//         suggestions: data.suggestions || [],
//         properties: data.properties || [],
//         metadata: data.metadata || {},
//         timestamp: new Date().toISOString()
//       };

//       setMessages(prev => [...prev, botMsg]);
      
//       if (!isOpen) {
//         setUnreadCount(prev => prev + 1);
//       }
//     } catch (error) {
//       console.error('[Chatbot] Error:', error);
//       setMessages(prev => [...prev, {
//         id: `err_${Date.now()}`,
//         role: 'bot',
//         content: "Désolé, une erreur technique s'est produite. Veuillez réessayer ou nous contacter directement.",
//         suggestions: ['Réessayer', 'Aide'],
//         properties: [],
//         timestamp: new Date().toISOString()
//       }]);
//     } finally {
//       setLoading(false);
//     }
//   }, [loading, sessionId, isOpen]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     sendMessage(input);
//   };

//   const handleSuggestionClick = (suggestion) => {
//     sendMessage(suggestion);
//   };

//   const formatMessage = (text) => {
//     // Convertir le markdown léger en JSX
//     return text
//       .split('\n')
//       .map((line, i) => (
//         <span key={i}>
//           {line.split(/(\*\*.*?\*\*)/).map((part, j) => {
//             if (part.startsWith('**') && part.endsWith('**')) {
//               return <strong key={j}>{part.slice(2, -2)}</strong>;
//             }
//             return part;
//           })}
//           {i < text.split('\n').length - 1 && <br />}
//         </span>
//       ));
//   };

//   return (
//     <>
//       {/* Bouton flottant */}
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="chatbot-toggle"
//         aria-label="Ouvrir le chat"
//       >
//         {isOpen ? <FiX size={24} /> : (
//           <div style={{ position: 'relative' }}>
//             <FiMessageCircle size={28} />
//             {unreadCount > 0 && !isOpen && (
//               <span className="chatbot-badge">{unreadCount}</span>
//             )}
//           </div>
//         )}
//       </button>

//       {/* Fenêtre de chat */}
//       {isOpen && (
//         <div className="chatbot-window">
//           {/* Header */}
//           <div className="chatbot-header">
//             <div className="chatbot-header-info">
//               <div className="chatbot-avatar">🤖</div>
//               <div>
//                 <div className="chatbot-title">Assistant MaliImmo</div>
//                 <div className="chatbot-status">
//                   <span className="status-dot" /> En ligne
//                 </div>
//               </div>
//             </div>
//             <button onClick={() => setIsOpen(false)} className="chatbot-close" aria-label="Fermer">
//               <FiX size={20} />
//             </button>
//           </div>

//           {/* Messages */}
//           <div className="chatbot-messages">
//             {messages.map((msg) => (
//               <div key={msg.id} className={`message-group ${msg.role}`}>
//                 <div className={`message-bubble ${msg.role}`}>
//                   <div className="message-text">{formatMessage(msg.content)}</div>
                  
//                   {/* Cartes de propriétés */}
//                   {msg.properties && msg.properties.length > 0 && (
//                     <div className="properties-grid">
//                       {msg.properties.map((prop) => (
//                         <a 
//                           key={prop.id} 
//                           href={`/announcements/${prop.id}`}
//                           className="property-card"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <div className="property-image">
//                             {prop.image ? (
//                               <img src={prop.image} alt={prop.title} loading="lazy" />
//                             ) : (
//                               <div className="property-image-placeholder">
//                                 <FiHome size={24} />
//                               </div>
//                             )}
//                             <span className="property-badge">{prop.type}</span>
//                           </div>
//                           <div className="property-info">
//                             <div className="property-title">{prop.title}</div>
//                             <div className="property-location">
//                               <FiMapPin size={12} /> {prop.location}
//                             </div>
//                             <div className="property-details">{prop.details}</div>
//                             <div className="property-footer">
//                               <span className="property-price">{prop.price}</span>
//                               {prop.agency && (
//                                 <span className="property-agency">{prop.agency}</span>
//                               )}
//                             </div>
//                           </div>
//                         </a>
//                       ))}
//                     </div>
//                   )}

//                   {/* Suggestions */}
//                   {msg.suggestions && msg.suggestions.length > 0 && (
//                     <div className="suggestions-row">
//                       {msg.suggestions.map((s, i) => (
//                         <button
//                           key={`${msg.id}-sugg-${i}`}
//                           onClick={() => handleSuggestionClick(s)}
//                           className="suggestion-chip"
//                         >
//                           {s}
//                         </button>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="message-time">
//                   {new Date(msg.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
//                 </div>
//               </div>
//             ))}

//             {/* Typing indicator */}
//             {loading && (
//               <div className="message-group bot">
//                 <div className="message-bubble bot typing">
//                   <div className="typing-dots">
//                     <span /><span /><span />
//                   </div>
//                 </div>
//               </div>
//             )}
//             <div ref={messagesEndRef} />
//           </div>

//           {/* Input */}
//           <form onSubmit={handleSubmit} className="chatbot-input-area">
//             <input
//               ref={inputRef}
//               type="text"
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               placeholder="Écrivez votre message..."
//               disabled={loading}
//               className="chatbot-input"
//             />
//             <button
//               type="submit"
//               disabled={loading || !input.trim()}
//               className={`chatbot-send ${!input.trim() ? 'disabled' : ''}`}
//             >
//               {loading ? <FiLoader className="spin" size={18} /> : <FiSend size={18} />}
//             </button>
//           </form>
//         </div>
//       )}
//     </>
//   );
// };

// export default ChatbotWidget;

import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FiMessageCircle, FiX, FiSend, FiMapPin, FiHome, FiLoader } from 'react-icons/fi';
import { chatbotAPI } from '../../services/api';

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessionId] = useState(() => {
    const saved = localStorage.getItem('chatbot_session_id');
    if (saved) return saved;
    const id = `sess_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('chatbot_session_id', id);
    return id;
  });
  
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isFirstOpen, setIsFirstOpen] = useState(true);

  // Message d'accueil initial
  useEffect(() => {
    if (messages.length === 0) {
      setMessages([{
        id: 'welcome',
        role: 'bot',
        content: "Bonjour ! 👋\n\nJe suis l'assistant de **MaliImmo**. Je peux vous aider à trouver un bien à louer ou à acheter. Que recherchez-vous ?",
        suggestions: ['Louer un appartement', 'Acheter une maison', 'Aide'],
        properties: [],
        timestamp: new Date().toISOString()
      }]);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => inputRef.current?.focus(), 100);
      setIsFirstOpen(false);
      setUnreadCount(0);
    }
  }, [messages, isOpen]);

  const sendMessage = useCallback(async (text) => {
    if (!text.trim() || loading) return;
    
    const userMsg = { 
      id: `u_${Date.now()}`, 
      role: 'user', 
      content: text, 
      timestamp: new Date().toISOString() 
    };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setLoading(true);

    try {
      const { data } = await chatbotAPI.chat({ 
        message: text, 
        session_id: sessionId,
        agency_id: null
      });
      
      const botMsg = {
        id: `b_${Date.now()}`,
        role: 'bot',
        content: data.response || "Je n'ai pas compris, pouvez-vous reformuler ?",
        suggestions: data.suggestions || [],
        properties: data.properties || [],
        metadata: data.metadata || {},
        timestamp: new Date().toISOString()
      };

      setMessages(prev => [...prev, botMsg]);
      
      if (!isOpen) {
        setUnreadCount(prev => prev + 1);
      }
    } catch (error) {
      console.error('[Chatbot] Error:', error);
      setMessages(prev => [...prev, {
        id: `err_${Date.now()}`,
        role: 'bot',
        content: "Désolé, une erreur s'est produite. Veuillez réessayer.",
        suggestions: ['Réessayer', 'Aide'],
        properties: [],
        timestamp: new Date().toISOString()
      }]);
    } finally {
      setLoading(false);
    }
  }, [loading, sessionId, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMessage(input);
  };

  const handleSuggestionClick = (suggestion) => {
    sendMessage(suggestion);
  };

  const formatMessage = (text) => {
    if (!text) return null;
    return text.split('\n').map((line, i) => (
      <span key={i}>
        {line.split(/(\*\*.*?\*\*)/).map((part, j) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={j}>{part.slice(2, -2)}</strong>;
          }
          return <span key={j}>{part}</span>;
        })}
        {i < text.split('\n').length - 1 && <br />}
      </span>
    ));
  };

  return (
    <>
      {/* Bouton flottant */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="chatbot-toggle"
        aria-label="Ouvrir le chat"
      >
        {isOpen ? <FiX size={24} /> : (
          <div style={{ position: 'relative' }}>
            <FiMessageCircle size={28} />
            {unreadCount > 0 && !isOpen && (
              <span className="chatbot-badge">{unreadCount}</span>
            )}
          </div>
        )}
      </button>

      {/* Fenêtre de chat */}
      {isOpen && (
        <div className="chatbot-window">
          {/* Header */}
          <div className="chatbot-header">
            <div className="chatbot-header-info">
              <div className="chatbot-avatar">🤖</div>
              <div>
                <div className="chatbot-title">Assistant MaliImmo</div>
                <div className="chatbot-status">
                  <span className="status-dot" /> En ligne
                </div>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="chatbot-close" aria-label="Fermer">
              <FiX size={20} />
            </button>
          </div>

          {/* Messages */}
          <div className="chatbot-messages">
            {messages.map((msg) => (
              <div key={msg.id} className={`message-group ${msg.role}`}>
                <div className={`message-bubble ${msg.role}`}>
                  <div className="message-text">{formatMessage(msg.content)}</div>
                  
                  {/* ═══ CARTES DE PROPRIÉTÉS ═══ */}
                  {msg.properties && msg.properties.length > 0 && (
                    <div className="properties-grid">
                      {msg.properties.map((prop) => (
                        <a 
                          key={prop.id} 
                          href={`/announcements/${prop.id}`}
                          className="property-card"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            // Optionnel : navigation SPA sans reload
                            // e.preventDefault();
                            // navigate(`/announcements/${prop.id}`);
                          }}
                        >
                          <div className="property-image">
                            {prop.image ? (
                              <img src={prop.image} alt={prop.title} loading="lazy" />
                            ) : (
                              <div className="property-image-placeholder">
                                <FiHome size={24} />
                              </div>
                            )}
                            <span className="property-badge">{prop.type}</span>
                          </div>
                          <div className="property-info">
                            <div className="property-title">{prop.title}</div>
                            <div className="property-location">
                              <FiMapPin size={12} /> {prop.location}
                            </div>
                            <div className="property-details">{prop.details}</div>
                            <div className="property-footer">
                              <span className="property-price">{prop.price}</span>
                              {prop.agency && (
                                <span className="property-agency">{prop.agency}</span>
                              )}
                            </div>
                          </div>
                        </a>
                      ))}
                    </div>
                  )}

                  {/* Suggestions */}
                  {msg.suggestions && msg.suggestions.length > 0 && (
                    <div className="suggestions-row">
                      {msg.suggestions.map((s, i) => (
                        <button
                          key={`${msg.id}-sugg-${i}`}
                          onClick={() => handleSuggestionClick(s)}
                          className="suggestion-chip"
                        >
                          {s}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <div className="message-time">
                  {new Date(msg.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            ))}

            {loading && (
              <div className="message-group bot">
                <div className="message-bubble bot typing">
                  <div className="typing-dots">
                    <span /><span /><span />
                  </div>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <form onSubmit={handleSubmit} className="chatbot-input-area">
            <input
              ref={inputRef}
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Écrivez votre message..."
              disabled={loading}
              className="chatbot-input"
            />
            <button
              type="submit"
              disabled={loading || !input.trim()}
              className={`chatbot-send ${!input.trim() ? 'disabled' : ''}`}
            >
              {loading ? <FiLoader className="spin" size={18} /> : <FiSend size={18} />}
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default ChatbotWidget;